export const numberFormat = (num, locale = 'en-US', customOptions = {}) => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...customOptions,
  };

  return new Intl.NumberFormat(locale, options).format(num);
};
